// 优先级数字，越大优先级越高
export enum GlobalModalPriority {
  // 新手引导
  BEGINNER_GUIDE = 999,

  // 激活任务
  ACTIVATION = 30,

  // VIP
  VIP_ACTIVITY = 20,

  // 活动中心 签到任务
  ACTIVITY_SIGN = 10,

  // 活动中心 新人引导（Tour）
  ACTIVITY_TOUR = 5,

  // AI 周报 Popover 引导（最低优先级）
  AI_REPORT_POPOVER = 1
}
